const LS_TOOLBAR_DEVELOPER_DRAWER_IS_HORIZONTAL = 'toolbarDeveloperDrawerIsHorizontal';
const DEVELOPER_DRAWER_DEFAULT_HEIGHT = '50vh';
const DEVELOPER_DRAWER_DEFAULT_WIDTH = '50vw';
const DEVELOPER_DRAWER_TABS = Object.freeze({
  DEVICE_LOGS: 'DEVELOPER_DRAWER_DEVICE_LOGS',
  DEV_TOOLS: 'DEVELOPER_DRAWER_DEV_TOOLS',
  APPIUM_INSPECTOR: 'DEVELOPER_DRAWER_APPIUM_INSPECTOR',
});

const RESIZE_THROTTLE_TIMEOUT_MS = 100;

export default {
  DEVELOPER_DRAWER_DEFAULT_HEIGHT,
  DEVELOPER_DRAWER_DEFAULT_WIDTH,
  DEVELOPER_DRAWER_TABS,
  LS_TOOLBAR_DEVELOPER_DRAWER_IS_HORIZONTAL,
  RESIZE_THROTTLE_TIMEOUT_MS,
};
